import moment from 'moment';
import _ from 'lodash';

const getMonth = (availability, selectedMonth, index) => (availability
	.find(({ startDate }) => moment.utc(new Date(selectedMonth))
		.add(index, 'months')
		.isSame(startDate, 'month')) || { days: [] }).days;

/**
 * Returns a new set of calendar days to render, starting from the first day of the week
 * before the 1st of the month, ending at the last day of the week after the last of the month
 * @param {Array} availability - array of objects of the form:
 *   { startDate: {UTC}, days: [{ date: {UTC}, timeSlots: [{ startDatetime: {UTC}, endDatetime: {UTC} }] }] }
 * @param {UTC} selectedMonth - the start of the month to generate days for
 * @param {UTC} selectedDate - the currently selected date
 * @param {UTC} today - the current date
 * @returns {Object} object of the form:
 *  { calendarDays: [], availabilityForLastMonth: {Boolean}, availabilityForNextMonth: {Boolean} }
 */
export default (availability, selectedMonth, selectedDate, today) => {
	const calendarStart = moment.utc(new Date(selectedMonth)).startOf('month').startOf('week');
	const calendarEnd = moment.utc(new Date(selectedMonth)).endOf('month').endOf('week');

	const lastMonth = getMonth(availability, selectedMonth, -1);
	const currentMonth = getMonth(availability, selectedMonth, 0);
	const nextMonth = getMonth(availability, selectedMonth, 1);

	const hasAvailability = day => day.timeSlots && day.timeSlots.length;

	const isSameWeek = date => day => moment.utc(new Date(date)).isSame(day.date, 'week');
	const calendarDays = _.flatten([
		lastMonth.filter(isSameWeek(calendarStart)),
		currentMonth.map(day => ({ ...day, isCurrentMonth: true })),
		nextMonth.filter(isSameWeek(calendarEnd))
	])
		.filter(month => !!month)
		.map(day => ({ ...day, isToday: today === day.date, isSelected: selectedDate === day.date }));

	return {
		calendarDays,
		availabilityForLastMonth: lastMonth.some(hasAvailability),
		availabilityForNextMonth: nextMonth.some(hasAvailability)
	};
};
